import { render, staticRenderFns } from "./ExpenseDetailReport.vue?vue&type=template&id=796e7d48"
import script from "./ExpenseDetailReport.vue?vue&type=script&lang=js"
export * from "./ExpenseDetailReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports